import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  FormInput,
  Form,
  FormGroup,
  Button,
  Modal,
  ModalBody,
  ModalHeader
} from "shards-react";
import { Table } from "react-bootstrap";
import { firebaseRemoteConfig, firebaseStorage } from "../../firebase";
import "./userDetails/tab.css";
import { fetchAndActivate, getAll } from "firebase/remote-config";
import { getDownloadURL, ref } from "firebase/storage";
import axios from "axios";

const Settings = () => {
  const BASE_URL = process.env;
  const [remoteConfigData, setRemoteConfigData] = useState([]);
  const [AccelerometerSpeed, setAccelerometerSpeed] = useState("");
  const [DefaultCalibration, setDefaultCalibration] = useState("");
  const [DefaultCalibrationMoment, setDefaultCalibrationMoment] = useState("");
  const [DefaultProgramWeeks, setDefaultProgramWeeks] = useState("");
  const [DefaultUserSpeed, setDefaultUserSpeed] = useState("");
  const [RecommendedSessionsPerWeek, setRecommendedSessionsPerWeek] = useState(
    ""
  );
  const [
    CalibrationStandardDeviation,
    setCalibrationStandardDeviation
  ] = useState("");
  const [TrainingStandardDeviation, setTrainingStandardDeviation] = useState(
    ""
  );
  const [acc_modal, setAccModal] = useState(false);
  const [dc_modal, setDcModal] = useState(false);
  const [dcm_modal, setDcmModal] = useState(false);
  const [dpw_modal, setDpwModal] = useState(false);
  const [dus_modal, setDusModal] = useState(false);
  const [rsw_modal, setRswModal] = useState(false);
  const [csd_modal, setCsdModal] = useState(false);
  const [tsd_modal, setTsdModal] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  //const [error, setError] = useState('');
  useEffect(() => {
    getRemoteConfigs();
  }, []);

  const accModal = () => {
    setAccModal(!acc_modal);
  };
  const dcModal = () => {
    setDcModal(!dc_modal);
  };
  const dcmModal = () => {
    setDcmModal(!dcm_modal);
  };
  const dpwModal = () => {
    setDpwModal(!dpw_modal);
  };
  const dusModal = () => {
    setDusModal(!dus_modal);
  };
  const rswModal = () => {
    setRswModal(!rsw_modal);
  };
  const csdModal = () => {
    setCsdModal(!csd_modal);
  };
  const tsdModal = () => {
    setTsdModal(!tsd_modal);
  };

  const showInstructionPDF = async () => {
    const fileRef = ref(
      firebaseStorage,
      remoteConfigData.InstructionPdf._value
    );
    const url = await getDownloadURL(fileRef);
    window.open(url);
  };

  const getRemoteConfigs = async () => {
    const data = getAll(firebaseRemoteConfig);
    setRemoteConfigData(data);
    setDefaultCalibration(JSON.parse(data.DefaultCalibration._value));
    setAccelerometerSpeed(data.Accelerometer_Speed._value);
    setDefaultCalibrationMoment(data.DefaultCalibrationMoment._value);
    setDefaultProgramWeeks(data.DefaultProgramWeeks._value);
    setDefaultUserSpeed(data.DefaultUserSpeed._value);
    setRecommendedSessionsPerWeek(data.RecommendedSessionsPerWeek._value);
    setCalibrationStandardDeviation(data.Calibration_Standard_Deviation._value);
    setTrainingStandardDeviation(data.Training_Standard_Deviation._value);
  };

  const UpdateAccelerometerSpeed = async () => {
    setActionLoading(true);
    axios
      .post(BASE_URL.REACT_APP_API_URL + `/admin/UpdateAccelerometerSpeed`, {
        data: AccelerometerSpeed
      })
      .then(res => {
        fetchAndActivate(firebaseRemoteConfig);
        setActionLoading(false);
      })
      .catch(error => {
        setActionLoading(false);
        //setError(error.message);
      });
  };

  const UpdateDefaltCalibration = async () => {
    setActionLoading(true);
    axios
      .post(BASE_URL.REACT_APP_API_URL + `/admin/UpdateDefaltCalibration`, {
        data: JSON.stringify(DefaultCalibration)
      })
      .then(res => {
        fetchAndActivate(firebaseRemoteConfig);
        setActionLoading(false);
      })
      .catch(error => {
        setActionLoading(false);
        //setError(error.message);
      });
  };

  const UpdateDefaultCalibrationMoment = async () => {
    setActionLoading(true);
    axios
      .post(
        BASE_URL.REACT_APP_API_URL + `/admin/UpdateDefaultCalibrationMoment`,
        { data: DefaultCalibrationMoment }
      )
      .then(res => {
        fetchAndActivate(firebaseRemoteConfig);
        setActionLoading(false);
      })
      .catch(error => {
        setActionLoading(false);
        // setError(error.message);
      });
  };

  const UpdateDefaultProgramWeeks = async () => {
    setActionLoading(true);
    axios
      .post(BASE_URL.REACT_APP_API_URL + `/admin/UpdateDefaultProgramWeeks`, {
        data: DefaultProgramWeeks
      })
      .then(res => {
        fetchAndActivate(firebaseRemoteConfig);
        setActionLoading(false);
      })
      .catch(error => {
        setActionLoading(false);
        // setError(error.message);
      });
  };

  const UpdateDefaultUserSpeed = async () => {
    setActionLoading(true);
    axios
      .post(BASE_URL.REACT_APP_API_URL + `/admin/UpdateDefaultUserSpeed`, {
        data: DefaultUserSpeed
      })
      .then(res => {
        fetchAndActivate(firebaseRemoteConfig);
        setActionLoading(false);
      })
      .catch(error => {
        setActionLoading(false);
        // setError(error.message);
      });
  };

  const UpdateRecommendedSessionsPerWeek = async () => {
    setActionLoading(true);
    axios
      .post(
        BASE_URL.REACT_APP_API_URL + `/admin/UpdateRecommendedSessionsPerWeek`,
        { data: RecommendedSessionsPerWeek }
      )
      .then(res => {
        fetchAndActivate(firebaseRemoteConfig);
        setActionLoading(false);
      })
      .catch(error => {
        setActionLoading(false);
        //  setError(error.message);
      });
  };

  const UpdateCalibrationStandardDeviation = async () => {
    setActionLoading(true);
    axios
      .post(
        BASE_URL.REACT_APP_API_URL +
          `/admin/UpdateCalibrationStandardDeviation`,
        {
          data: CalibrationStandardDeviation
        }
      )
      .then(res => {
        fetchAndActivate(firebaseRemoteConfig);
        setActionLoading(false);
      })
      .catch(error => {
        setActionLoading(false);
        //  setError(error.message);
      });
  };

  const UpdateTrainingStandardDeviation = async () => {
    setActionLoading(true);
    axios
      .post(
        BASE_URL.REACT_APP_API_URL + `/admin/UpdateTrainingStandardDeviation`,
        {
          data: TrainingStandardDeviation
        }
      )
      .then(res => {
        fetchAndActivate(firebaseRemoteConfig);
        setActionLoading(false);
      })
      .catch(error => {
        setActionLoading(false);
        //  setError(error.message);
      });
  };

  return (
    <Container fluid className="main-content-container px-4 pb-4">
      {remoteConfigData !== "" ? (
        <Row className="page-header py-4">
          <Col sm="12" md="12">
            <Card small className="mb-1 pt-1">
              <Table bordered>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Value</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Accelerometer Speed</td>
                    <td>{AccelerometerSpeed}</td>
                    <td>
                      <i
                        className="material-icons text-primary"
                        style={{ cursor: "pointer" }}
                        onClick={accModal}
                      >
                        edit
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td>Default Calibration</td>
                    <td>
                      <pre>{JSON.stringify(DefaultCalibration, null, 2)}</pre>
                    </td>
                    <td>
                      <i
                        className="material-icons text-primary"
                        style={{ cursor: "pointer" }}
                        onClick={dcModal}
                      >
                        edit
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td>Default Calibration Moment</td>
                    <td>{DefaultCalibrationMoment}</td>
                    <td>
                      <i
                        className="material-icons text-primary"
                        style={{ cursor: "pointer" }}
                        onClick={dcmModal}
                      >
                        edit
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td>Default Program Weeks</td>
                    <td>{DefaultProgramWeeks}</td>
                    <td>
                      <i
                        className="material-icons text-primary"
                        style={{ cursor: "pointer" }}
                        onClick={dpwModal}
                      >
                        edit
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td>Default User Speed</td>
                    <td>{DefaultUserSpeed}</td>
                    <td>
                      <i
                        className="material-icons text-primary"
                        style={{ cursor: "pointer" }}
                        onClick={dusModal}
                      >
                        edit
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td>Recommended Sessions per Week</td>
                    <td>{RecommendedSessionsPerWeek}</td>
                    <td>
                      <i
                        className="material-icons text-primary"
                        style={{ cursor: "pointer" }}
                        onClick={rswModal}
                      >
                        edit
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td>Instruction PDF</td>
                    <td>
                      <i
                        className="material-icons text-danger"
                        style={{ cursor: "pointer" }}
                        onClick={showInstructionPDF}
                      >
                        visibility
                      </i>
                    </td>
                    <td>
                      <i
                        className="material-icons text-primary"
                        style={{ cursor: "pointer" }}
                      >
                        edit
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td>Calibration Standard Deviation</td>
                    <td>{CalibrationStandardDeviation}</td>
                    <td>
                      <i
                        className="material-icons text-primary"
                        style={{ cursor: "pointer" }}
                        onClick={csdModal}
                      >
                        edit
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td>Training Standard Deviation</td>
                    <td>{TrainingStandardDeviation}</td>
                    <td>
                      <i
                        className="material-icons text-primary"
                        style={{ cursor: "pointer" }}
                        onClick={tsdModal}
                      >
                        edit
                      </i>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Card>
          </Col>
          <Modal open={acc_modal} toggle={accModal}>
            <ModalHeader>Accelerometer Speed</ModalHeader>
            <ModalBody>
              <Form>
                <FormGroup>
                  <label htmlFor="#Accelerometer">Accelerometer Speed</label>
                  <FormInput
                    id="#Accelerometer"
                    placeholder="Enter Speed"
                    type="number"
                    value={AccelerometerSpeed}
                    onChange={e => setAccelerometerSpeed(e.target.value)}
                  />
                </FormGroup>
                {actionLoading && <>Updating...</>}
                <Button
                  theme="success"
                  className="submit_button"
                  disabled={actionLoading}
                  onClick={() => UpdateAccelerometerSpeed()}
                >
                  Submit
                </Button>
              </Form>
            </ModalBody>
          </Modal>
          <Modal open={dc_modal} toggle={dcModal}>
            <ModalHeader>Default Calibration</ModalHeader>
            <ModalBody>
              <Form>
                <Row>
                  <Col sm="6" md="6" lg="6">
                    <FormGroup>
                      <label htmlFor="#pendlumLength">pendlum Length</label>
                      <FormInput
                        id="#pendlumLength"
                        placeholder="pendlum Length"
                        type="number"
                        value={DefaultCalibration.pendlumLength}
                        onChange={e =>
                          setDefaultCalibration({
                            ...DefaultCalibration,
                            pendlumLength: e.target.value
                          })
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col sm="6" md="6" lg="6">
                    <FormGroup>
                      <label htmlFor="#offsetValue">offset Value</label>
                      <FormInput
                        id="#offsetValue"
                        placeholder="offset Value"
                        type="number"
                        value={DefaultCalibration.offsetValue}
                        onChange={e =>
                          setDefaultCalibration({
                            ...DefaultCalibration,
                            offsetValue: e.target.value
                          })
                        }
                      />
                    </FormGroup>
                  </Col>
                  <h6>Device Dimensions : </h6>
                  <Col sm="6" md="6" lg="6">
                    <FormGroup>
                      <label htmlFor="#height">Height</label>
                      <FormInput
                        id="#height"
                        placeholder="Height"
                        type="number"
                        value={
                          DefaultCalibration.deviceDimensions
                            ? DefaultCalibration.deviceDimensions.height
                            : ""
                        }
                        onChange={e =>
                          setDefaultCalibration({
                            ...DefaultCalibration,
                            deviceDimensions: {
                              ...DefaultCalibration.deviceDimensions,
                              height: e.target.value
                            }
                          })
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col sm="6" md="6" lg="6">
                    <FormGroup>
                      <label htmlFor="#pixelRatio">Pixel Ratio</label>
                      <FormInput
                        id="#pixelRatio"
                        placeholder="pixel Ratio"
                        type="number"
                        value={
                          DefaultCalibration.deviceDimensions
                            ? DefaultCalibration.deviceDimensions.pixelRatio
                            : ""
                        }
                        onChange={e =>
                          setDefaultCalibration({
                            ...DefaultCalibration,
                            deviceDimensions: {
                              ...DefaultCalibration.deviceDimensions,
                              pixelRatio: e.target.value
                            }
                          })
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col sm="6" md="6" lg="6">
                    <FormGroup>
                      <label htmlFor="#width">Width</label>
                      <FormInput
                        id="#width"
                        placeholder="Width"
                        type="number"
                        value={
                          DefaultCalibration.deviceDimensions
                            ? DefaultCalibration.deviceDimensions.width
                            : ""
                        }
                        onChange={e =>
                          setDefaultCalibration({
                            ...DefaultCalibration,
                            deviceDimensions: {
                              ...DefaultCalibration.deviceDimensions,
                              width: e.target.value
                            }
                          })
                        }
                      />
                    </FormGroup>
                  </Col>
                </Row>
                {actionLoading && <>Updating...</>}
                <Button
                  theme="success"
                  className="submit_button"
                  disabled={actionLoading}
                  onClick={() => UpdateDefaltCalibration()}
                >
                  Submit
                </Button>
              </Form>
            </ModalBody>
          </Modal>
          <Modal open={dcm_modal} toggle={dcmModal}>
            <ModalHeader>Default Calibration Moment</ModalHeader>
            <ModalBody>
              <Form>
                <FormGroup>
                  <label htmlFor="#DefaultCalibrationMoment">
                    {" "}
                    Default Calibration Moment
                  </label>
                  <FormInput
                    id="#DefaultCalibrationMoment"
                    placeholder="Enter Moment"
                    type="number"
                    value={DefaultCalibrationMoment}
                    onChange={e => setDefaultCalibrationMoment(e.target.value)}
                  />
                </FormGroup>
                {actionLoading && <>Updating...</>}
                <Button
                  theme="success"
                  className="submit_button"
                  disabled={actionLoading}
                  onClick={() => UpdateDefaultCalibrationMoment()}
                >
                  Submit
                </Button>
              </Form>
            </ModalBody>
          </Modal>
          <Modal open={dpw_modal} toggle={dpwModal}>
            <ModalHeader>Program Weeks</ModalHeader>
            <ModalBody>
              <Form>
                <FormGroup>
                  <label htmlFor="#DefaultProgramWeeks">
                    Default Program Weeks
                  </label>
                  <FormInput
                    id="#DefaultProgramWeeks"
                    placeholder="Enter Value"
                    type="number"
                    value={DefaultProgramWeeks}
                    onChange={e => setDefaultProgramWeeks(e.target.value)}
                  />
                </FormGroup>
                {actionLoading && <>Updating...</>}
                <Button
                  theme="success"
                  className="submit_button"
                  disabled={actionLoading}
                  onClick={() => UpdateDefaultProgramWeeks()}
                >
                  Submit
                </Button>
              </Form>
            </ModalBody>
          </Modal>
          <Modal open={dus_modal} toggle={dusModal}>
            <ModalHeader>User Speed</ModalHeader>
            <ModalBody>
              <Form>
                <FormGroup>
                  <label htmlFor="#DefaultUserSpeed">Default User Speed</label>
                  <FormInput
                    id="#DefaultUserSpeed"
                    placeholder="Enter Speed"
                    type="number"
                    value={DefaultUserSpeed}
                    onChange={e => setDefaultUserSpeed(e.target.value)}
                  />
                </FormGroup>
                {actionLoading && <>Updating...</>}
                <Button
                  theme="success"
                  className="submit_button"
                  disabled={actionLoading}
                  onClick={() => UpdateDefaultUserSpeed()}
                >
                  Submit
                </Button>
              </Form>
            </ModalBody>
          </Modal>
          <Modal open={rsw_modal} toggle={rswModal}>
            <ModalHeader>Recommended Sessions per Week</ModalHeader>
            <ModalBody>
              <Form>
                <FormGroup>
                  <label htmlFor="#RecommendedSessionsPerWeek">
                    Recommended Sessions Per Week
                  </label>
                  <FormInput
                    id="#RecommendedSessionsPerWeek"
                    placeholder="Enter Value"
                    type="number"
                    value={RecommendedSessionsPerWeek}
                    onChange={e =>
                      setRecommendedSessionsPerWeek(e.target.value)
                    }
                  />
                </FormGroup>
                {actionLoading && <>Updating...</>}
                <Button
                  theme="success"
                  className="submit_button"
                  disabled={actionLoading}
                  onClick={() => UpdateRecommendedSessionsPerWeek()}
                >
                  Submit
                </Button>
              </Form>
            </ModalBody>
          </Modal>
          <Modal open={csd_modal} toggle={csdModal}>
            <ModalHeader>Standard Deviation</ModalHeader>
            <ModalBody>
              <Form>
                <FormGroup>
                  <label htmlFor="#StandardDeiation">
                    Calibration Standard Deviation
                  </label>
                  <FormInput
                    id="#CalibrationStandardDeviation"
                    placeholder="Enter Calibration Standard Deviation"
                    type="number"
                    value={CalibrationStandardDeviation}
                    onChange={e =>
                      setCalibrationStandardDeviation(e.target.value)
                    }
                  />
                </FormGroup>
                {actionLoading && <>Updating...</>}
                <Button
                  theme="success"
                  className="submit_button"
                  disabled={actionLoading}
                  onClick={() => UpdateCalibrationStandardDeviation()}
                >
                  Submit
                </Button>
              </Form>
            </ModalBody>
          </Modal>
          <Modal open={tsd_modal} toggle={tsdModal}>
            <ModalHeader>Training Standard Deviation</ModalHeader>
            <ModalBody>
              <Form>
                <FormGroup>
                  <label htmlFor="#StandardDeiation">
                    Training Standard Deviation
                  </label>
                  <FormInput
                    id="#TrainingStandardDeviation"
                    placeholder="Enter Training Standard Deviation"
                    type="number"
                    value={TrainingStandardDeviation}
                    onChange={e => setTrainingStandardDeviation(e.target.value)}
                  />
                </FormGroup>
                {actionLoading && <>Updating...</>}
                <Button
                  theme="success"
                  className="submit_button"
                  disabled={actionLoading}
                  onClick={() => UpdateTrainingStandardDeviation()}
                >
                  Submit
                </Button>
              </Form>
            </ModalBody>
          </Modal>
        </Row>
      ) : (
        <div className="wrapper">
          <div className="spinner">
            <div className="spinner-1"></div>
            <div className="spinner-2"></div>
            <div className="spinner-3"></div>
          </div>
        </div>
      )}
    </Container>
  );
};

export default Settings;
